/* global axios */
import ApiClient from '../ApiClient';

class ElectoralCampaignTasksAPI extends ApiClient {
  constructor() {
    super('electoral_campaign/tasks', {
      accountScoped: true,
      apiVersion: 'v2',
    });
  }

  list({ category, status } = {}) {
    const params = {};
    if (category) params.category = category;
    if (status) params.status = status;
    return axios.get(this.url, { params });
  }

  create(payload) {
    return axios.post(this.url, payload);
  }

  update(id, payload) {
    return axios.patch(`${this.url}/${id}`, payload);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new ElectoralCampaignTasksAPI();
